<template>
    <div class="video-box">
        <div id="fb-root"></div>
        <div class="video-wrap" ref="video" v-html="embedVideo"></div>
    </div>
</template>

<script>
import util from '@/common/util';

export default {
    inject: ['bannerVideo'],
    props: {
        src: {
            type: String,
            default: ''
        },
        autoplay: {
            type: Boolean,
            default: false
        },
        muted: {
            type: Boolean,
            default: false
        },
        controls: {
            type: Boolean,
            default: false
        },
        playsinline: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            videoStyle: {},
            embedVideo: '',
            appId: '5915489508564870',
            videoRatio: 9 / 16
        };
    },
    mounted() {
        this.$videoDom = this.$refs.video;
        if (this.bannerVideo) {
            this.bannerVideo.$once('hook:mounted', () => {
                this.$nextTick(() => {
                    this.videoInit();
                });
            });
        } else {
            console.log('bannerVideo vm is not exit');
        }
    },
    watch: {
        src() {
            this.bannerVideo.$emit('changeVideo');
            this.videoInit();
        }
    },
    methods: {
        videoInit() {
            let _this = this;
            let bannerDom = this.bannerVideo.$el;
            _this.bannerVideo.$emit('setFacebook');

            _this.embedVideo = `
                <div class="fb-video"
                    ref="nofollow"
                    data-href="${_this.src}"
                    data-allowfullscreen="true"
                    data-show-captions="true"
                    data-autoplay="${_this.autoplay}"
                    data-width=${Math.ceil(bannerDom.offsetWidth)}
                    data-height=${Math.ceil(bannerDom.offsetHeight)}
                ></div>
            `;

            util.addScript('https://connect.facebook.net/en_US/sdk.js').then(
                () => {
                    FB.init({
                        appId: _this.appId,
                        xfbml: true,
                        version: 'v16.0'
                    });
                    FB.Event.subscribe('xfbml.ready', function (msg) {
                        if (msg.type === 'video') {
                            _this.videoPlayer = msg.instance;
                            _this.$emit('loadedmetadata');
                            _this.$emit('canplay');
                            _this.$emit('play');

                            if (_this.autoplay && _this.videoPlayer.play) {
                                _this.playVideo();
                                _this.toggleMuted(true);
                            }

                            _this.bindEvent();
                        }
                    });
                }
            );
        },
        calcVideoStyle() {
            //banner-video need videoRatio
            return this.videoRatio;
        },
        bindEvent() {
            let _this = this;
            _this.videoPlayer.subscribe('startedPlaying', function () {
                _this.$emit('play');
            });

            _this.videoPlayer.subscribe('paused', function () {
                _this.$emit('pause');
            });

            _this.videoPlayer.subscribe('finishedPlaying', function () {
                _this.$emit('ended');
            });

            _this.videoPlayer.subscribe('error', function (err) {
                _this.$emit('error', err);
            });
        },
        playVideo() {
            this.videoPlayer.play();
        },
        pauseVideo() {
            this.videoPlayer.pause();
        },
        toggleMuted(muted) {
            if (muted) {
                this.videoPlayer.mute();
            } else {
                this.videoPlayer.unmute();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.video-box {
    position: relative;
    width: 100%;
    height: 100%;
    .video-wrap {
        height: 100%;
        width: 100%;
        /deep/ .fb-video {
            width: 100% !important;
            height: 100% !important;
            text-align: center;
            span {
                width: 100% !important;
                height: 100% !important;
            }
            iframe {
                width: 100%;
                height: 100%;
            }
        }
    }
    .video-action {
        position: absolute;
        .iconfont {
            position: absolute;
            width: 36px;
            height: 36px;
            left: 20px;
            bottom: 20px;
            font-size: 16px;
            color: #fff;
            border-radius: 4px;
            z-index: 9;
            cursor: pointer;
            text-align: center;
            vertical-align: middle;
            line-height: 36px;
            &::after {
                background: #282828;
                opacity: 0.3;
                border-radius: 4px;
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                content: '';
                z-index: -1;
            }
        }
    }
}
</style>
